import React, { useEffect } from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { TRANSLATION_CONSTANTS } from '../../app-consts/translations';
import { datadogRum } from '@datadog/browser-rum';
import { Button, Type } from 'mesh-component-library';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import { callCustomerServicePhone } from '../../utilities/PhoneUtils';

export const CallUs = () => {
  const getTranslatedText = useLocale();
  const partnerDetails = useSelector(
    (state: RootState) => state.partnerDetails.partnerDetails
  );
  const submitRequest = useSelector((state: RootState) => state.submitRequest);
  const callId = submitRequest?.response?.callId || '';
  const usageId = submitRequest?.response?.usageId || '';
  const isSubmitComplete = !!callId && !!usageId;

  useEffect(() => {
    datadogRum.addAction('User lands on Call us page');
    document.title = 'CallUs | Roadside Assistance';
    window.scrollTo(1, 1);
  }, []);

  const handleCallClick = () => {
    datadogRum.addAction('User clicked Call Us button from CallUs page');
    // Rental / alternate transportation requests are handled by a live rep, so stay on this screen.
    callCustomerServicePhone(partnerDetails?.phone, "CallUsScreen");
  };

  return (
        <div role="main" className="l-container-callus static" id="call_us_ride">
          <div className='l-container-callus__button_content d-flex flex-column'>
            <Type
              variant="brand"
              align="left"
              size="3xl"
              weight="semibold"
              lineHeight="md"
              data-testid="call-us-title"
              className="l-container-callus__hd u-vr-3 u-hr-2"
            >
              {getTranslatedText(TRANSLATION_CONSTANTS.CALL_US_FOR_RIDE_SCREEN_TITLE)}
            </Type>
            <Type
              variant="brand"
              align="left"
              lineHeight="md"
              data-testid="call-us-text_1"
              className="l-container-callus__text u-vr-3 u-hr-2"
            >
              {getTranslatedText(TRANSLATION_CONSTANTS.CALL_US_FOR_RIDE_SCREEN_BODY)}
            </Type>
          </div>
          <div className='l-container-callus__button_footer d-flex flex-column'>
            <Button
              size="lg"
              hasUpgrade
              id="call_us"
              utils={{ fullWidth: true }}
              onClick={handleCallClick}
              disabled={!isSubmitComplete}
              aria-label="Callus screen live representative Button"
            >
              {getTranslatedText(TRANSLATION_CONSTANTS.LIVE_REPRESENTATIVE)}
            </Button>
          </div>
        </div>
  );
};

